document.addEventListener('DOMContentLoaded', function() {
    const customDropdowns = document.querySelectorAll('.grind-note');
    if (!customDropdowns.length) return;
    
    customDropdowns.forEach(function(customDropdown) {
        const buttonInput = customDropdown.querySelector('input[type="radio"]');
        const customTrigger = customDropdown.querySelector('.custom-select-trigger');
        const customOptions = customDropdown.querySelector('.custom-select-options');
        const placeholder = customDropdown.querySelector('.custom-select-placeholder');
        
        if (!customTrigger || !customOptions || !placeholder) return;
        
        // Check if it is inside a product-utils-component
        const productCategoryFieldset = customDropdown.closest('[data-product-utils]');
        const productUtilsCheckbox = productCategoryFieldset?.querySelector('.product-utils-checkbox');
        const isInsideProductUtils = !!productCategoryFieldset;
        
        let grindTypeProperty;
        let productForm;
        let propertyName;
        
        // Find the correct form for this product (in case there are multiple on the page)
        const section = customDropdown.closest('section');
        if (!section) return;
        
        productForm = section.querySelector('form[data-type="add-to-cart-form"]');
        if (!productForm) return;
        
        // Determine property name based on product category or default
        const productCategory = productCategoryFieldset?.dataset.productUtils;
        propertyName = productCategory 
            ? `properties[${productCategory} Grind Type]` 
            : 'properties[Grind Type]';
        
        // Function to manage property input (create/remove based on context)
        function managePropertyInput(value) {
            if (!productForm || !propertyName) return;
            
            const currentValue = String(value || '');
            const shouldExist = isInsideProductUtils 
                ? (productUtilsCheckbox && productUtilsCheckbox.checked)
                : true; // Standalone: always exists
            
            // Check if property input exists
            grindTypeProperty = productForm.querySelector(`input[name="${propertyName}"]`);
            
            if (shouldExist && currentValue) {
                // Create or update property input
                if (!grindTypeProperty) {
                    grindTypeProperty = document.createElement('input');
                    grindTypeProperty.type = 'hidden';
                    grindTypeProperty.name = propertyName;
                    productForm.appendChild(grindTypeProperty);
                }
                grindTypeProperty.value = currentValue;
            } else {
                // Remove property input if checkbox unchecked or value empty
                if (grindTypeProperty) {
                    grindTypeProperty.remove();
                    grindTypeProperty = null;
                }
            }
        }
        
        // Function to get current value
        function getCurrentValue() {
            if (buttonInput && buttonInput.checked) {
                return buttonInput.value;
            }
            // Check if dropdown has selection
            const selectedOption = customOptions.querySelector('.custom-select-option.selected');
            if (selectedOption) {
                return selectedOption.dataset.value || '';
            }
            return '';
        }
        
        // Initialize property based on context
        if (isInsideProductUtils) {
            // Inside product-utils: only create if checkbox is checked
            if (productUtilsCheckbox && productUtilsCheckbox.checked) {
                const initialValue = buttonInput ? buttonInput.value : '';
                managePropertyInput(initialValue);
            }
        } else {
            // Standalone: always create with initial value
            const initialValue = buttonInput ? buttonInput.value : '';
            managePropertyInput(initialValue);
        }
        
        let isOpen = false;
        
        // Toggle dropdown functionality
        customTrigger.addEventListener('click', function() {
            isOpen = !isOpen;
            customDropdown.classList.toggle('is-open', isOpen);
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!customDropdown.contains(e.target)) {
                isOpen = false;
                customDropdown.classList.remove('is-open');
            }
        });
        
        // Handler for dropdown options
        customOptions.addEventListener('click', function(e) {
            const option = e.target.closest('.custom-select-option');
            if (!option) return;
            
            const value = option.dataset.value;
            const label = option.textContent.trim();
            
            // Update UI of dropdown
            placeholder.textContent = label;
            customOptions.querySelectorAll('.custom-select-option').forEach(opt => {
                opt.classList.remove('selected');
            });
            option.classList.add('selected');
            customDropdown.classList.add('has-selection');
            
            // Uncheck button
            if (buttonInput && buttonInput.checked) {
                buttonInput.checked = false;
            }
            
            // Update property input
            managePropertyInput(value);
            
            // Close dropdown
            isOpen = false;
            customDropdown.classList.remove('is-open');
        });
        
        // When clicking the button, update the property input
        if (buttonInput) {
            buttonInput.addEventListener('change', function(e) {
                // Stop propagation so it won't propagate to variant-selects
                e.stopPropagation();
                
                if (this.checked) {
                    customOptions.querySelectorAll('.custom-select-option').forEach(opt => {
                        opt.classList.remove('selected');
                    });
                    customDropdown.classList.remove('has-selection');
                    
                    managePropertyInput(this.value);
                }
            });
        }
        
        // Listen to checkbox changes (if inside product-utils)
        if (productUtilsCheckbox) {
            productUtilsCheckbox.addEventListener('change', function() {
                if (this.checked) {
                    // Checkbox checked: create property with current value
                    const currentValue = getCurrentValue();
                    managePropertyInput(currentValue);
                } else {
                    // Checkbox unchecked: remove property
                    managePropertyInput('');
                }
            });
        }
    });
});